import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ requiredRole }) => {
    const isAuthenticated = localStorage.getItem('is_authenticated');
    const role = localStorage.getItem('role');

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (requiredRole) {
        if (role !== requiredRole) {
            return <Navigate to="/unauthorized" />;
        }
    }

    return <Outlet />;
};

export default ProtectedRoute;
